/* global ActiveXObject */
'use strict';

import * as UrlUtil from './url';
import { localStorage } from './storage';

var UA = {
	CANALDIGITAL: 'adb',
	ANDROID: 'android',
	ANDROID4: 'android 4',
	ANDROID5: 'android 5',
	CHROME: 'chrome',
	FIREFOX: 'firefox',
	IE: 'msie',
	IE11: 'trident/7.0',
	EDGE: 'edge',
	INETTV: 'inettvbrowser', // Sony
	IPHONE: 'iphone',
	IPAD: 'ipad',
	IPOD: 'ipod',
	IOS5: 'os 5',
	IOS6: 'os 6',
	IOS7: 'os 7',
	IOS9: 'os 9',
	LG: 'lg browser',
	MAC: 'mac',
    MAC_OS_HIGH_SIERRA: 'mac os x 10_13',
	NETCAST: 'netcast',
	PANASONIC: 'viera',
	PHILIPS: 'philips',
	PS4: 'playstation 4',
	SAFARI: 'safari',
	SAMSUNG: 'samsung',
	SONYCE: 'sonycebrowser',
	VERSION: 'version', // use with iOS to find mobile safari
	WEBOS: 'webos',
	WIIU: 'nintendo wiiu',
	WIN8: 'msapphost/2.0',
	WP: 'windows phone',
	WP_DESKTOP: 'wpdesktop',
	XP: 'windows nt 5.1'
};

var UA_SETTINGS = {
	fullScreen: [UA.PS4, UA.SONYCE, UA.INETTV, UA.PHILIPS],
	hlsCapable: [UA.PS4, UA.LG, UA.WIIU, UA.WEBOS, UA.NETCAST],
	hlsOnly: [UA.CANALDIGITAL, UA.PHILIPS, UA.SONYCE, UA.INETTV, UA.PANASONIC],
	iOS: [UA.IPAD, UA.IPHONE, UA.IPOD],
	iOSMobile: [UA.IPHONE, UA.IPOD],
	maxQuality: [UA.PS4, UA.LG, UA.WIIU, UA.SONYCE, UA.INETTV, UA.PANASONIC, UA.PHILIPS, UA.CANALDIGITAL],
	windowsPhone: [UA.WP, UA.WP_DESKTOP]
};

var CURR_UA = navigator.userAgent.toLowerCase(),
	SUPPORTS_FLASH;

module.exports = (function () {


	function _matchUserAgent(ua) {
		return CURR_UA.indexOf(ua) !== -1;
	}

	function _matchUserAgentList(uaList) {

		for (var i = 0; i < uaList.length; i++) {
			if (_matchUserAgent(uaList[i])) {
				return true;
			}
		}

		return false;
	}

	function _getAndroidVersion() {
		if (!isAndroid()) {
			return {};
		}

		var androidMajorMinor = CURR_UA.replace(/.*android (\d\.\d).*/, '$1').split('.');
        var major = Number(androidMajorMinor[0]);
        var minor = Number(androidMajorMinor[1]);

		return {
			major: major,
			minor: minor
		};
	}

	function _getChromeVersion() {
		if (!_matchUserAgent(UA.CHROME)) {
			return {
				major: 0,
				minor: 0
			};
		}

		var chromeMajorMinor = CURR_UA.replace(/.*chrome\/(\d+\.\d+).*/, '$1').split('.');
        var major = Number(chromeMajorMinor[0]);
        var minor = Number(chromeMajorMinor[1]);

		return {
			major: major,
			minor: minor
		};
	}

	function _getEdgeVersion() {
		if (!_matchUserAgent(UA.EDGE)) {
			return {
				major: 0,
				minor: 0
			};
		}

		const edgeMajorMinor = CURR_UA.replace(/.*edge\/(\d+\.\d+).*/, '$1').split('.'),
			major = Number(edgeMajorMinor[0]),
			minor = Number(edgeMajorMinor[1]);

		return {
			major: major,
			minor: minor
		};
	}

	function isIE() {
		return _matchUserAgent(UA.IE);
	}

	function isEdge() {
		return _matchUserAgent(UA.EDGE);
	}

	function isIOS() {
		return _matchUserAgentList(UA_SETTINGS.iOS) && !_matchUserAgent(UA.WP);
	}

	function isIOS5() {
		return isIOS() && _matchUserAgent(UA.IOS5);
	}

	function isIOSLte7() {
		return isIOS() && (_matchUserAgent(UA.IOS7) || _matchUserAgent(UA.IOS6) || _matchUserAgent(UA.IOS5));
	}

	function isIOSApp() {
		return localStorage.getItem('svtapp') === 'ios-app' || UrlUtil.getQueryParameter('svtapp') === 'play-ios-app';
	}

	function isIOSNotSafari() {
		return isIOS() && !_matchUserAgent(UA.VERSION);
	}

	function isBrokenAndroidChrome() {
		return isAndroid() && _getChromeVersion().major <= 30;
	}

	function isWindowsXpFirefox() {
		return _matchUserAgent(UA.FIREFOX) && _matchUserAgent(UA.XP);
	}

	function isMacDesktopSafari() {
		return _matchUserAgent(UA.SAFARI) && _matchUserAgent(UA.MAC) &&
			!_matchUserAgent(UA.CHROME) && !_matchUserAgent(UA.WP) && !isIOS();
	}

	function isDesktopChrome() {
		return _matchUserAgent(UA.CHROME) && window.chrome &&
			!(isIOS() || isAndroid() || isEdge());
	}

	function isDesktopFirefox() {
		return _matchUserAgent(UA.FIREFOX) &&
				!(isIOS() || isAndroid() || isEdge());
	}

	function isDesktopEdge() {
		return _matchUserAgent(UA.EDGE) &&
			!(isIOS() || isAndroid());
	}

	function isHlsOnlyDevice() {
		return _matchUserAgentList(UA_SETTINGS.hlsOnly);
	}

	function isDashIncapableAndroid() {
		if (isAndroid()) {
			var version = _getAndroidVersion();

			return version.major <= 5 && _matchUserAgent(UA.SAMSUNG);
		}

		return false;
	}

	function isHttpLiveStreamingCapable(videoElement) {
		return isIOS() || isMacDesktopSafari() ||
			_getAndroidVersion().major >= 5 ||
			_matchUserAgentList(UA_SETTINGS.hlsCapable) ||
			isHlsOnlyDevice() ||
			(videoElement && videoElement.canPlayType && !!videoElement.canPlayType('application/vnd.apple.mpegurl;codecs="avc1.77.30, mp4a.40.2"'));
	}

	function isAndroid() {
		return _matchUserAgent(UA.ANDROID) && !_matchUserAgent(UA.WP);
	}

	function isAndroidApp() {
		return !!window.SvtPlayAndroid;
	}

	function isWindowsPhone() {
		return _matchUserAgentList(UA_SETTINGS.windowsPhone);
	}

	function isWindows8App() {
		return _matchUserAgent(UA.WIN8);
	}

	function isMacOS() {
		return _matchUserAgent(UA.MAC);
	}

	function isFlashCapable() {
		return !isAndroid() && !isIOS() && !isWindowsPhone() && !isWindows8App();
	}

	function isDashCapable() {
		return !!window.MediaSource && !isMacDesktopSafari() && !isWindowsXpFirefox() && !isDashIncapableAndroid();
	}

	function isDashLiveCapable() {
		return isDashCapable() && isDesktopChrome();
	}

	function isHlsJsCapable() {
		return !!window.MediaSource && !!window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.5"');
	}

	function isRedirectCapable() {
		return (isDesktopChrome() && _getChromeVersion().major > 37 && _getChromeVersion().major !== 55) ||
			isMacDesktopSafari() ||
			isDesktopFirefox() ||
			(isIOS() && !isIOSLte7()) ||
			(isDesktopEdge() && _getEdgeVersion().major >= 17);
	}

	function isAirplayCapable() {
		return isMacDesktopSafari() || (_matchUserAgent(UA.IOS9) && _matchUserAgent(UA.IPAD));
	}

	function isPictureInPictureCapable(videoElement) {
		return typeof videoElement.webkitSupportsPresentationMode === 'function' &&
				videoElement.webkitSupportsPresentationMode('picture-in-picture');
	}

	function isTouch() {
		return (('ontouchstart' in window) ||
			(navigator.MaxTouchPoints > 0) ||
			(navigator.msMaxTouchPoints > 0));
	}

	function isAndroidIntentCapable() {
		if (isAndroid()) {
			var chromeVersion = _getChromeVersion();

			return (chromeVersion.major > 40);
		}

		return false;
	}

	function forceAndroidFallbackMode() {
		if (isAndroid()) {
			var version = _getAndroidVersion();
            var chromeVersion = _getChromeVersion();

            // Android version < 4.4 is not supported.
            const isUnsupportedAndroidVersion = version.major < 4 || (version.major < 5 && version.minor < 4);
            if (isUnsupportedAndroidVersion) {
                return true;
            }

            // Chrome < 40 is not supported.
            // For some browsers, e.g. Firefox, chromeVersion.major will be 0.
            const isUnsupportedChromeVersion = chromeVersion.major > 0 && chromeVersion.major < 40;

            return isUnsupportedChromeVersion;
		}

		return false;
	}

	function supportsShockwaveFlash() {
		if (SUPPORTS_FLASH === undefined) {
			let hasFlash = false;
			try {
				if (new ActiveXObject('ShockwaveFlash.ShockwaveFlash')) {
					hasFlash = true;
				}
			} catch (e) {
				if (navigator.mimeTypes &&
					navigator.mimeTypes['application/x-shockwave-flash'] !== undefined &&
					navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
					hasFlash = true;
				}
			}
			SUPPORTS_FLASH = hasFlash;
		}

		return SUPPORTS_FLASH;
	}

	function toString() {
		return 'Device info: \n' +
				'User agent = ' + CURR_UA + '\n' +
				'isDashCapable = ' + isDashCapable() + '\n' +
				'supportsShockwaveFlash = ' + supportsShockwaveFlash() + '\n' +
				'isFlashCapable = ' + isFlashCapable() + '\n' +
				'isHlsOnlyDevice = ' + isHlsOnlyDevice() + '\n' +
				'isHlsJsCapable = ' + isHlsJsCapable() + '\n' +
				'forceAndroidFallbackMode = ' + forceAndroidFallbackMode() + '\n' +
				'isRedirectCapable = ' + isRedirectCapable() + '\n' +
				'isTouch = ' + isTouch();
	}

	return {
		forceAndroidFallbackMode: forceAndroidFallbackMode,
		isBrokenAndroidChrome: isBrokenAndroidChrome,
		isDesktopChrome: isDesktopChrome,
		isMacDesktopSafari: isMacDesktopSafari,
		isIE: isIE,
		isIOS: isIOS,
		isIOS5: isIOS5,
		isIOSLte7: isIOSLte7,
		isIOSApp: isIOSApp,
		isIOSNotSafari: isIOSNotSafari,
		isAndroid: isAndroid,
		isAndroidApp: isAndroidApp,
		isMacOS: isMacOS,
		isTouch: isTouch,
		isWindowsPhone: isWindowsPhone,
		isWindows8App: isWindows8App,
		isFlashCapable: isFlashCapable,
		isRedirectCapable: isRedirectCapable,
		isAndroidIntentCapable : isAndroidIntentCapable,
		isAirplayCapable: isAirplayCapable,
		isPictureInPictureCapable: isPictureInPictureCapable,
		supportsDash: isDashCapable,
		supportsDashLive: isDashLiveCapable,
		supportsHls: isHttpLiveStreamingCapable,
		supportsHlsJs: isHlsJsCapable,
		supportsFlash: supportsShockwaveFlash,
		toString: toString
	};
})();



// WEBPACK FOOTER //
// ./src/js/util/device.js